import styled from "styled-components";
import Colors from "../../../../Constant/Colors";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;
export const BackIcon = styled.span`
margin-right: 10px;
cursor: pointer;
`;  

export const DetailView = styled.div`
width: 100%;
height: 100%;
display: flex;
padding: 10px;
flex-wrap: wrap;
min-width: 200px;
min-height: 750px;
margin-right: 10px;
box-sizing: border-box;
flex-direction: column;
align-items: flex-start;
overflow-y: scroll;
overflow-x: scroll;
padding-bottom: 40px;
&::-webkit-scrollbar {
  display: none;
}
scrollbar-width: none;
`;

export const SkillCircle = styled.div`
width: 25px;
height: 25px;
margin-right: 15px;
border-radius: 50px;
border: 1px solid #6666;
background-color: ${props => props.index+1 <= props.skill ? Colors.primary : Colors.whiteThemeColor};

`;
